import axios from 'axios'
import { authStorageKey } from '../routes/auth'
import { sanitizeHeadersAndParams } from '../shared/api/interceptors'

/**
 * Centralized Axios HTTP Client
 * Configured with base URL, request timeout, default headers,
 * Bearer token authorization interceptor, and global error handling.
 */
const defaultBaseUrl = 'https://api.ledryt.com'
// const defaultBaseUrl = 'https://huddle-unspoiled-explicit.ngrok-free.dev'
const API_BASE_URL = import.meta.env.VITE_API_BASE_URL !== undefined && import.meta.env.VITE_API_BASE_URL !== ''
  ? import.meta.env.VITE_API_BASE_URL.replace(/\/+$/, '')
  : defaultBaseUrl

export const apiClient = axios.create({
  baseURL: API_BASE_URL,
  timeout: 15000,
  withCredentials: false,
  headers: {
    'Content-Type': 'application/json',
    'ngrok-skip-browser-warning': 'true',
    Accept: 'application/json',
  },
})

// Request Interceptor: Attach Bearer access_token from localStorage & sanitize empty headers/params
apiClient.interceptors.request.use(
  (config) => {
    const token = window.localStorage.getItem('access_token')
    if (token && config.headers) {
      config.headers.Authorization = `Bearer ${token}`
    }
    sanitizeHeadersAndParams(config)

    return config
  },
  (error) => Promise.reject(error)
)

// Response Interceptor: Global 401 Unauthorized handling & error formatting
apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Clear token if session is unauthenticated or expired
      const isAuthenticated = window.localStorage.getItem(authStorageKey) === 'true'
      if (isAuthenticated) {
        window.localStorage.removeItem('access_token')
      }
    }
    return Promise.reject(error)
  }
)

export default apiClient
